/* ft-teile.js (14.10.2026 abends, Sitzung Webshop, Testshop-Umbau nach Pascal: „in der suche wenn ich jetzt nach hsn tsn, direkt
   über fahrzeugauswahl oder auch die suchfunktion gehe sehe ich 3 völlig unterschiedliche seiten“). Gemeinsamer Kern für den EINEN
   Teilefinder (snippets/ft-teilefinder) und die EINE Trefferseite (/search, assets/ft-treffer.js):
   - Erkennung der Eingabe: Schlüsselnummer (HSN/TSN), Teilenummer, Fahrzeug (Marke, Modell, Motor aus dem Suchwort)
   - Fahrzeugdaten (assets/ft-fahrzeuge-fahrzeug-<marke>.json, 36_fahrzeugdaten_bauen.py) und Suchindex (235_suchindex_bauen.py)
   - Schlüsselnummer zum Fahrzeug: Artikel mit dem Schlagwort hsn-<hsn><tsn> über die Vorschlagssuche, dann deren Fahrzeugzeilen
     (templates/product.ft-passung), nur Zeilen mit genau dieser Nummer
   - Karten der Artikel (section_id=ft-karte) und die Adresse der Trefferseite für ein Fahrzeug
   Konfiguration aus sections/ft-header.liquid: window.FtTeileCfg = { index, muster }. */
(function () {
  if (window.FtTeile) return;
  var CFG = window.FtTeileCfg || {};

  var RANG = { L: 0, K: 1, S: 2, M: 3, A: 4, O: 5, H: 6, E: 7, Z: 8 };
  var ARTNAME = { L: 'Turbolader', K: 'Turbolader-Komplettset', S: 'Turbolader-Set', M: 'Turbolader-Montagesatz', A: 'VTG-Aktuator',
    O: 'Öl-/Wasserleitung', H: 'Ladeluftschlauch', E: 'Sensor' };
  /* Gruppen der Trefferseite und Schalter oben; Kategorie-Seiten verlinken mit art=<Code der Gruppe>.
     15.10.2026 abends (Pascal: „zubehör sollte nicht existieren weil ich sehe da verschiedene produktkategorien das sollte jeweils
     dastehen als eigene kategorie wie auch andere“): jede Art ist eine eigene Gruppe mit dem Namen der Kategorie im Shop, Bild
     (Schlüssel aus window.ftKopfBilder) und einem kurzen Satz, was das Teil ist. Teile ohne eigenes Kürzel (Z) bekommen ihre Gruppe
     nach der Produktart der Karte (data-ft-typ, ARTGRUPPE). ZUBEHOER: die Arten der früheren Gruppe „Zubehör“ (Kategorie-Seite
     Zubehör im Teilefinder, art=Z). */
  var GRUPPEN = [
    { code: 'L', name: 'Turbolader', arten: ['L'], bild: 'turbolader', satz: 'Der Lader selbst, neu oder generalüberholt.' },
    { code: 'K', name: 'Komplettsets', arten: ['K', 'S'], bild: 'turbolader-set', satz: 'Lader mit Einbauteilen in einem Paket. Was dabei ist, steht am Artikel.' },
    { code: 'M', name: 'Montagesätze', arten: ['M'], bild: 'montagesatz', satz: 'Dichtungen und Schrauben für den Einbau des Laders.' },
    { code: 'A', name: 'Stellmotoren', arten: ['A'], bild: 'aktuator', satz: 'Stellmotoren (VTG-Aktuatoren) für den Lader.' },
    { code: 'O', name: 'Öl- und Wasserleitungen', arten: ['O'], bild: 'oelleitung', satz: 'Leitungen für Öl und Kühlwasser am Lader.' },
    { code: 'H', name: 'Ladeluftschläuche', arten: ['H'], bild: 'ladeluftschlauch', satz: 'Schläuche für die Ladeluft zwischen Lader und Motor.' },
    { code: 'E', name: 'Sensoren', arten: ['E'], bild: 'sensoren', satz: '' },
    { code: 'Z', name: 'Weitere Teile', arten: ['Z'], bild: '', satz: '' }
  ];
  var ZUBEHOER = ['A', 'O', 'H', 'E', 'Z'];
  /* Produktart im Shop (product.type) → [Code, Name wie die Kategorie im Shop, Bild-Schlüssel] */
  var ARTGRUPPE = {
    'Abgaskrümmer': ['ZAK', 'Abgaskrümmer', 'abgaskruemmer'],
    'Abgasklappe / Motorbremse': ['ZAM', 'Abgasklappen und Motorbremse', 'abgasklappe'],
    'AGR-Ventil': ['ZAV', 'AGR-Ventile', 'agr-ventil-neu'],
    'AGR-Modul': ['ZAG', 'AGR-Module', 'agr-modul'],
    'AGR-Sperrklappe': ['ZAS', 'AGR-Sperrklappen', ''],
    'Kühler / AGR-Rückführung': ['ZKA', 'Kühler und AGR-Rückführung', 'kuehler-agr'],
    'Ansaugschlauch / Luftfilter': ['ZAN', 'Ansaugschläuche und Luftfilter', 'ansaugschlauch'],
    'Kühlerschlauch': ['ZKS', 'Kühlerschläuche', 'kuehlerschlauch'],
    'Kupplungssatz': ['ZKU', 'Kupplungssätze', 'kupplungssatz'],
    'Kupplung / Kühlerlüfter': ['ZKL', 'Lüfterkupplungen', ''],
    'Druckdose': ['ZDD', 'Druckdosen', 'druckdose'],
    'Rumpfgruppe (CHRA)': ['ZRG', 'Rumpfgruppen (CHRA)', 'chra-rumpfgruppe'],
    'Dieselpartikelfilter (DPF)': ['ZDP', 'Dieselpartikelfilter', 'dieselpartikelfilter']
  };
  function gruppeVon(art, typ) {
    var a = (art === 'Z' || !art) && typ && ARTGRUPPE[typ];
    if (a) return { code: a[0], name: a[1], arten: ['Z'], bild: a[2], satz: '' };
    for (var i = 0; i < GRUPPEN.length; i++) if (GRUPPEN[i].arten.indexOf(art) > -1) return GRUPPEN[i];
    return GRUPPEN[GRUPPEN.length - 1];
  }

  var STOPP = {};
  ('turbolader turbo turbos lader abgasturbolader neu neue neuer neues original generaluberholt uberholt austausch austauschlader ' +
   'fur fuer von vom der die das den dem mit und oder kaufen preis gunstig billig teil teile ersatzteil ersatzteile auto pkw oe nr ' +
   'nummer motor motorcode diesel benzin baujahr bj ps kw set komplettset satz montagesatz passend passt zu')
    .split(' ').forEach(function (w) { STOPP[w] = 1; });
  var TYP = {};
  ('tdi tsi tfsi fsi tdci hdi dci cdi crdi cdti jtd jtdm multijet ecoboost tce d i t td tds sdi gti gtd bitdi d4d dti ctdi tgi ' +
   'etsi bluehdi bluetdi tddi di vtec dtec idtec crd mjet').split(' ').forEach(function (w) { TYP[w] = 1; });
  var AUFBAU = {};
  'variant avant touring kombi turnier limousine stufenheck cabrio cabriolet coupe roadster kasten bus van sportback sportsvan alltrack allroad pritsche'
    .split(' ').forEach(function (w) { AUFBAU[w] = 1; });
  var ROEM = ['', 'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x', 'xi', 'xii'];
  var GROSS = {};
  'GT GTI GTD GTE GTS CC R RS ST SW TT LT ID AMG CLA CLK CLS CL SL SLK SLC GL GLA GLB GLC GLE GLK GLS ML XC XE XF XJ DS MPV SUV CDI TDI TSI HDI VW BMW'
    .split(' ').forEach(function (w) { GROSS[w] = 1; });

  function klein(s) { return String(s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, ''); }
  function n(s) { return klein(s).replace(/[^a-z0-9]/g, ''); }
  function mnorm(s) { return klein(String(s || '').replace(/\([^)]*\)/g, ' ')).replace(/,/g, '.').replace(/[^a-z0-9.]/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function jahreText(j) { var s = String(j || '').trim(); var m = s.match(/^(\S+)\s*-\s*(\S*)$/); return m ? (m[2] ? m[1] + ' bis ' + m[2] : 'ab ' + m[1]) : s; }
  function zahl(s) { var m = String(s || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
  function kw(ps) { var z = zahl(ps); return z ? Math.round(z * 0.735499) : 0; }
  function slug(m) {
    var t = klein(m).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return { 'mercedes-benz': 'mercedes', 'volkswagen': 'vw', 'vw-volkswagen': 'vw' }[t] || t;
  }

  /* „GOLF VII Variant (BA5, BV5)“ → „Golf VII Variant (BA5, BV5)“; bei BMW „3 Touring“ → „3er Touring“ */
  function schoen(name) {
    var i = name.indexOf(' (');
    var basis = i > -1 ? name.slice(0, i) : name, rest = i > -1 ? name.slice(i) : '';
    return basis.split(' ').map(function (w) {
      return w.split(/([\/-])/).map(function (t) {
        if (!t || /^[\/-]$/.test(t) || /^[IVX]+$/.test(t) || /\d/.test(t) || GROSS[t] || t !== t.toUpperCase()) return t;
        return t.charAt(0) + t.slice(1).toLowerCase();
      }).join('');
    }).join(' ') + rest;
  }
  function kurzName(name, markeSlug) {
    var i = String(name || '').indexOf(' (');
    var t = schoen(i > -1 ? name.slice(0, i) : String(name || ''));
    return markeSlug === 'bmw' ? t.replace(/^([1-8])(?=\s|$)/, '$1er') : t;
  }
  function codesText(name) { var m = String(name || '').match(/\(([^)]*)\)/); return m ? m[1] : ''; }
  function ohneKlammer(m) { return String(m || '').replace(/\s*\([^)]*\)/g, ''); }
  function markeSchoen(m) {
    var t = String(m || '').trim();
    if (!t) return '';
    if (t.length <= 3 || GROSS[t.toUpperCase()]) return t.toUpperCase();
    return t.split(/([\s-])/).map(function (w) { return /^[\s-]$/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join('');
  }

  /* ── Laden mit Zwischenspeicher je Seite ── */
  var cache = {};
  function json(url) {
    if (!url) return Promise.resolve(null);
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      cache[url].then(function (d) { if (!d) delete cache[url]; });
    }
    return cache[url];
  }
  function markenDatei(s) { return CFG.muster ? CFG.muster.replace(/ft-fahrzeuge-fahrzeug-vw\.json/, 'ft-fahrzeuge-fahrzeug-' + s + '.json') : ''; }
  function marke(s) { return json(markenDatei(s)).then(function (d) { return d && d.format === 2 ? d : null; }); }
  var idxVersprechen = null;
  function index() {
    if (!idxVersprechen) {
      idxVersprechen = json(CFG.index).then(function (d) {
        if (!d || !d.marken) { idxVersprechen = null; return null; }
        var idx = { marke: {}, markeWort: {}, modelle: d.modelle || {} };
        d.marken.forEach(function (m) {
          var o = { name: m[0], kennung: m[1] };
          idx.marke[m[1]] = o;
          (m[2] || []).forEach(function (w) { idx.markeWort[w] = o; });
        });
        return idx;
      });
    }
    return idxVersprechen;
  }

  /* ── Erkennung der Eingabe ── */
  var HSN1 = /^\s*(\d{4})\s*[\s\/.\-]\s*([0-9A-Za-z]{3})\s*$/;
  var HSN2 = /^\s*(\d{4})([A-Za-z][0-9A-Za-z]{2})\s*$/;
  var EIGEN = /^\s*(TLN|TLG|TLGK|TLNK|TLMS|TLAK|TLOL|VLL|MAKR)[\s\-]*(\d{3,6})\s*$/i;
  function art(roh) {
    var q = String(roh || '').trim();
    if (!q) return { typ: 'leer' };
    var m = HSN1.exec(q) || HSN2.exec(q);
    if (m) return { typ: 'hsn', hsn: m[1], tsn: m[2].toUpperCase(), code: m[1] + m[2].toUpperCase() };
    if (EIGEN.test(q)) return { typ: 'nummer', nummer: q.toUpperCase() };
    var stuecke = q.split(/\s+/), voll = '';
    for (var i = 0; i < stuecke.length; i++) {
      var a = stuecke[i].replace(/[^0-9A-Za-z]/g, '');
      if (a.length >= 6 && a.replace(/[^0-9]/g, '').length / a.length >= 0.4) { voll = stuecke[i]; break; }
    }
    if (voll) return { typ: 'nummer', nummer: voll };
    var al = q.replace(/[^0-9A-Za-z]/g, '');
    if (stuecke.length === 1 && al.length >= 3 && /\d/.test(al) && al.replace(/[^0-9]/g, '').length / al.length >= 0.4) return { typ: 'nummer', nummer: q, kurz: true };
    return { typ: 'text' };
  }

  function zerlegen(q, idx) {
    var s = klein(q).replace(/(\d),(\d)/g, '$1.$2');
    var motor = '', bmwReihe = '', m;
    if ((m = s.match(/(^|[^a-z0-9.])([1-8])(\d{2})\s?(d|i|e|xd|xi|sd|td)(?![a-z0-9])/))) {
      motor = m[2] + m[3] + m[4]; bmwReihe = m[2]; s = s.replace(m[0], m[1] + ' ');
    } else if ((m = s.match(/(^|[^0-9.])(\d\.\d)\s?([a-z0-9]{1,9})?/))) {
      if (m[3] && TYP[m[3]]) { motor = m[2] + m[3]; s = s.replace(m[0], m[1] + ' '); } else { motor = m[2]; s = s.replace(m[2], ' '); }
    } else if ((m = s.match(/(^|[^a-z0-9])(\d{3})\s?(cdi|d|bluetec|cgi)(?![a-z0-9])/))) {
      motor = m[2] + m[3]; s = s.replace(m[0], m[1] + ' ');
    }
    var w = [];
    s.split(/[^a-z0-9]+/).filter(Boolean).forEach(function (t) {
      if (idx.modelle[t] || idx.markeWort[t]) { w.push(t); return; }
      var k = t.match(/^([a-z]{3,})(\d{1,2})$/);
      if (k && idx.modelle[k[1]]) { w.push(k[1], k[2]); return; }
      k = t.match(/^mk(\d{1,2})$/);
      if (k) { w.push(k[1]); return; }
      w.push(t);
    });
    return { woerter: w.filter(function (t) { return !STOPP[t]; }), motor: motor, bmwReihe: bmwReihe };
  }
  function erkennen(z, idx) {
    var w = z.woerter, mk = null, modellWort = '', verbraucht = {};
    for (var i = 0; i < w.length && !mk; i++) {
      if (w[i + 1] && idx.markeWort[w[i] + w[i + 1]]) { mk = idx.markeWort[w[i] + w[i + 1]]; verbraucht[i] = verbraucht[i + 1] = 1; }
      else if (idx.markeWort[w[i]]) { mk = idx.markeWort[w[i]]; verbraucht[i] = 1; }
    }
    for (var j = 0; j < w.length && !modellWort; j++) {
      if (verbraucht[j]) continue;
      var paar = (w[j + 1] && !verbraucht[j + 1]) ? w[j] + w[j + 1] : '';
      var t = (paar && idx.modelle[paar]) ? paar : (idx.modelle[w[j]] ? w[j] : '');
      if (!t) continue;
      var ms = idx.modelle[t];
      if (mk && ms.indexOf(mk.kennung) === -1) continue;
      if (!mk && ms.length !== 1) continue;
      if (!mk) mk = idx.marke[ms[0]];
      modellWort = t;
      verbraucht[j] = 1;
      if (t === paar) verbraucht[j + 1] = 1;
    }
    if (!mk && z.bmwReihe) mk = idx.marke.bmw;
    if (!mk) return null;
    return { marke: mk, modellWort: modellWort, rest: w.filter(function (t, k) { return !verbraucht[k]; }), motor: z.motor, bmwReihe: z.bmwReihe,
      nurMarke: !modellWort && !(z.bmwReihe && mk.kennung === 'bmw') };
  }
  function modellInfo(name) {
    var i = name.indexOf(' (');
    var basis = i > -1 ? name.slice(0, i) : name;
    var codes = ((name.match(/\(([^)]*)\)/) || [])[1] || '').split(/[\s,\/]+/).map(n).filter(Boolean);
    return { w: basis.split(/[\s\/]+/).map(n).filter(Boolean), codes: codes };
  }
  function streng(t) { return /^\d{1,2}$/.test(t) || ROEM.indexOf(t) > 0 || AUFBAU[t] || (/\d/.test(t) && /^[a-z0-9]{2,6}$/.test(t)); }
  function passtWort(t, mi) {
    if (mi.w.indexOf(t) !== -1 || mi.codes.indexOf(t) !== -1) return true;
    if (/^\d{1,2}$/.test(t)) { var r = ROEM[+t]; return !!r && mi.w.indexOf(r) !== -1; }
    if (t.length >= 3 && /\d/.test(t)) return mi.codes.some(function (c) { return c.indexOf(t) !== -1; });
    return false;
  }
  function modelleFinden(daten, e) {
    var reihe = e.bmwReihe || ((/^([1-8])er$/.exec(e.modellWort) || [])[1]) || '';
    var liste = [];
    daten.modelle.forEach(function (m, i) {
      var mi = modellInfo(m.n);
      if (reihe) { if (mi.w[0] !== reihe) return; }
      else if (mi.w.indexOf(e.modellWort) === -1 && n(m.n.split(' (')[0]).indexOf(e.modellWort) !== 0) return;
      if (!e.rest.every(function (t) { return !streng(t) || passtWort(t, mi); })) return;
      var motoren = m.motoren.map(function (x, k) { return k; }).filter(function (k) { return !e.motor || mnorm(m.motoren[k].m).indexOf(e.motor) === 0; });
      liste.push({ m: m, i: i, mi: mi, motoren: motoren });
    });
    if (e.motor) {
      var mitMotor = liste.filter(function (x) { return x.motoren.length; });
      if (mitMotor.length) liste = mitMotor;
      else { e.motor = ''; liste.forEach(function (x) { x.motoren = x.m.motoren.map(function (y, k) { return k; }); }); }
    }
    function jahr(m) { var t = String(m.j || '').match(/(\d{4})/); return t ? +t[1] : 0; }
    var KOMBI = { variant: 1, avant: 1, touring: 1, kombi: 1, turnier: 1, stufenheck: 1, sportback: 1, limousine: 1 };
    function aufbau(x) { var w = x.mi.w.filter(function (t) { return AUFBAU[t] || !(t === e.modellWort || streng(t) || t === reihe); });
      return !w.length ? 0 : (w.every(function (t) { return KOMBI[t]; }) ? 1 : 2); }
    return liste.sort(function (a, b) { return (aufbau(a) - aufbau(b)) || (a.mi.w.length - b.mi.w.length) || (jahr(b.m) - jahr(a.m)) || a.m.n.localeCompare(b.m.n, 'de'); });
  }
  /* Fahrzeug im Suchwort: { marke:{name,kennung}, daten, modelle:[{m,i,motoren}], motor, nurMarke } oder null */
  function fahrzeugImText(q) {
    return index().then(function (idx) {
      if (!idx) return null;
      var e = erkennen(zerlegen(q, idx), idx);
      if (!e) return null;
      return marke(e.marke.kennung).then(function (d) {
        if (!d) return null;
        e.daten = d;
        e.modelle = e.nurMarke ? [] : modelleFinden(d, e);
        if (!e.nurMarke && !e.modelle.length) return null;
        return e;
      });
    });
  }
  function motorNamen(x) {
    var namen = [];
    x.motoren.forEach(function (k) { var m = x.m.motoren[k].m; if (namen.indexOf(m) === -1) namen.push(m); });
    return namen.sort(function (a, b) { return a.localeCompare(b, 'de', { numeric: true, sensitivity: 'base' }); });
  }
  function eintraege(x, name) {
    return x.motoren.filter(function (k) { return x.m.motoren[k].m === name; })
      .sort(function (a, b) { return (zahl(x.m.motoren[a].ps) - zahl(x.m.motoren[b].ps)) || (a - b); });
  }

  /* ── Fahrzeug, Fahrzeugzeile, Teile ── */
  /* Fahrzeug im Format von snippets/ft-fahrzeug-speicher aus einer Zeile der Fahrzeugdaten */
  function fahrzeugAus(daten, modell, e) {
    return { marke: daten.marke, modell: modell.n, motor: e.m, ps: e.ps, jahre: e.j,
      code: (e.c && e.c.length === 1) ? e.c[0] : '', ccm: e.cc || '', hsntsn: '' };
  }
  /* Zeile der Fahrzeugdaten zu einem Fahrzeug: gleiche Baureihe, Motor, PS; Baujahre und Hubraum, wenn bekannt */
  function zeileFinden(daten, v) {
    var treffer = null;
    daten.modelle.some(function (mo, mi) {
      if (n(mo.n) !== n(v.modell)) return false;
      var gute = [];
      mo.motoren.forEach(function (e, oi) {
        if (n(e.m) !== n(v.motor) || n(e.ps) !== n(v.ps)) return;
        var punkte = (v.jahre && e.j && n(e.j) === n(v.jahre) ? 2 : 0) + (v.ccm && e.cc && n(e.cc) === n(v.ccm) ? 1 : 0);
        if (v.jahre && e.j && n(e.j) !== n(v.jahre)) punkte -= 3;
        gute.push({ oi: oi, punkte: punkte });
      });
      if (!gute.length) return false;
      gute.sort(function (a, b) { return b.punkte - a.punkte; });
      treffer = { modell: mo, mi: mi, motor: mo.motoren[gute[0].oi], oi: gute[0].oi };
      return true;
    });
    return treffer;
  }
  function teileVon(daten, e) {
    return e.h.map(function (i) {
      var xs = (e.e && e.e[String(i)]) || [];
      return { handle: daten.p[i], art: daten.t[i] || 'Z', einschr: xs.map(function (k) { return daten.x[k]; }).filter(Boolean) };
    });
  }
  function fahrzeugText(v, mitJahren) {
    if (!v) return '';
    var s = kurzName(v.modell, slug(v.marke));
    /* Leistung wie im Fahrzeugschein zuerst in kW, PS in Klammern (Design-Bauplan: „110 kW (150 PS)“) */
    var t = [markeSchoen(v.marke), s].filter(Boolean).join(' ') + (v.motor ? ', ' + ohneKlammer(v.motor) : '') + (v.ps ? ', ' + (kw(v.ps) ? kw(v.ps) + ' kW (' + v.ps + ')' : v.ps) : '');
    return t + (mitJahren && v.jahre ? ', ' + jahreText(v.jahre) : '');
  }

  /* ── Schlüsselnummer zum Fahrzeug ── */
  function hsnFahrzeuge(code) {
    var c = String(code || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
    var url = '/search/suggest.json?q=' + encodeURIComponent('hsn-' + c.toLowerCase()) +
      '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bfields%5D=tag';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var p = (((d || {}).resources || {}).results || {}).products || [];
      var handles = p.map(function (x) { return x.handle; });
      /* Lader zuerst: ihre Fahrzeugzeilen sind am vollständigsten */
      handles.sort(function (a, b) { return (/^turbolader-(neu|generalueberholt)/.test(b) ? 1 : 0) - (/^turbolader-(neu|generalueberholt)/.test(a) ? 1 : 0); });
      return Promise.all(handles.slice(0, 3).map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?view=ft-passung', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; });
      })).then(function (listen) {
        var aus = [], gesehen = {};
        listen.forEach(function (zeilen) {
          (zeilen || []).forEach(function (z) {
            var nummern = String(z[6] || '').split(/[,;]/).map(function (s) { return s.toUpperCase().replace(/[^0-9A-Z]/g, ''); });
            if (nummern.indexOf(c) === -1) return;
            var k = [n(z[0]), n(z[1]), n(z[2]), n(z[3]), n(z[4])].join('|');
            if (gesehen[k]) return;
            gesehen[k] = 1;
            aus.push({ marke: String(z[0] || '').trim(), modell: z[1], motor: z[2], ps: z[3], jahre: z[4], code: z[5] || '', ccm: '', hsntsn: c });
          });
        });
        return { fahrzeuge: aus, artikel: handles.length };
      });
    }).catch(function () { return { fahrzeuge: [], artikel: 0 }; });
  }

  /* ── Karten ── */
  function karte(h) {
    return fetch('/products/' + encodeURIComponent(h) + '?section_id=ft-karte', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { if (!t) return null; var box = document.createElement('div'); box.innerHTML = t; return box.querySelector('.ft-pc'); })
      .catch(function () { return null; });
  }
  function nacheinander(liste, je, fn) {
    var erg = new Array(liste.length), pos = 0;
    function weiter() { if (pos >= liste.length) return Promise.resolve(); var i = pos++; return fn(liste[i], i).then(function (v) { erg[i] = v; return weiter(); }); }
    var laeufe = []; for (var k = 0; k < Math.min(je, liste.length); k++) laeufe.push(weiter());
    return Promise.all(laeufe).then(function () { return erg; });
  }
  function zustand(k) { return k.querySelector('.ft-pc-flag-seg.is-reman') ? 1 : 0; }
  function weg(k) { return k.classList.contains('is-soldout') ? 1 : 0; }

  /* ── Adressen ── */
  var FZ_FELDER = ['marke', 'modell', 'motor', 'ps', 'ccm', 'jahre', 'code'];
  function ergebnisUrl(v, extra) {
    if (!v || !v.marke) return '/search';
    var q = ['fz=1'].concat(FZ_FELDER.filter(function (k) { return v[k]; }).map(function (k) { return k + '=' + encodeURIComponent(v[k]); }));
    if (extra && extra.art) q.push('art=' + encodeURIComponent(extra.art));
    if (extra && extra.hsn) q.push('hsn=' + encodeURIComponent(extra.hsn));
    return '/search?' + q.join('&');
  }
  function vonUrl(p) {
    if (!p.get('fz') || !p.get('marke')) return null;
    var v = { hsntsn: '' };
    FZ_FELDER.forEach(function (k) { v[k] = p.get(k) || ''; });
    return v;
  }

  var WA = 'https://wa.me/491748416161';
  function waLink(text) { return WA + '?text=' + encodeURIComponent(text); }

  window.FtTeile = {
    RANG: RANG, ARTNAME: ARTNAME, GRUPPEN: GRUPPEN, ZUBEHOER: ZUBEHOER, gruppeVon: gruppeVon,
    esc: esc, n: n, klein: klein, slug: slug, kw: kw, zahl: zahl, jahreText: jahreText, schoen: schoen, kurzName: kurzName,
    codesText: codesText, ohneKlammer: ohneKlammer, markeSchoen: markeSchoen, mnorm: mnorm,
    json: json, marke: marke, index: index,
    art: art, fahrzeugImText: fahrzeugImText, motorNamen: motorNamen, eintraege: eintraege,
    fahrzeugAus: fahrzeugAus, zeileFinden: zeileFinden, teileVon: teileVon, fahrzeugText: fahrzeugText,
    hsnFahrzeuge: hsnFahrzeuge, karte: karte, nacheinander: nacheinander, zustand: zustand, weg: weg,
    ergebnisUrl: ergebnisUrl, vonUrl: vonUrl, waLink: waLink
  };
  try { window.dispatchEvent(new CustomEvent('ft-teile-bereit')); } catch (e) {}
})();
